<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >apps</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.modules' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>

      <div></div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      <mat-table #table [dataSource]="dataSource" id="matrixModulesPage"
        class="products-table" fusePerfectScrollbar>

        @for (disCol of displayedColumns; track disCol; let colIndex = $index) {
          <ng-container matColumnDef="{{disCol}}">
            <mat-header-cell *matHeaderCellDef
            [ngClass]="{'edit': disCol === 'edit'}">{{disCol | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element "
              [ngClass]="{'edit': disCol === 'edit'}">
              @if (disCol !== 'edit' && disCol !== 'organization_title') {
                @if (!element[disCol]) {
                  <mat-icon class="close">close</mat-icon>
                }
                @if (element[disCol]) {
                  <mat-icon class="done">done</mat-icon>
                }
              }
              @if (disCol === 'edit') {
                <mat-icon (click)="editPlatform(element[disCol])" class="edit-icon">edit</mat-icon>
              }
              @if (disCol === 'organization_title') {
                {{element[disCol]}}
              }
            </mat-cell>
          </ng-container>
        }

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <mat-paginator #paginator
        [length]="_total"
        [pageIndex]="_pageIndex"
        [pageSize]="_perPage"
        [pageSizeOptions]="[25, 50, 100]"
        (page)="changePageEmitter($event)">
      </mat-paginator>

    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
